import React from 'react';
import { Html } from 'cccisd-wysiwyg';
import striptags from 'striptags';
import style from '../style.css';

const toDisplayText = val => {
    if (val === null || val === undefined) return '';
    if (typeof val === 'string') return val;
    if (typeof val !== 'object') return String(val);
    if ('content' in val) return toDisplayText(val.content);
    const numericValues = Object.keys(val)
        .filter(k => !Number.isNaN(Number(k)))
        .sort((a, b) => Number(a) - Number(b))
        .map(k => val[k]);
    if (numericValues.length) {
        return numericValues.map(v => toDisplayText(v)).join('');
    }
    return '';
};

const DragDropRender = ({ widget, metricsData, answerBg }) => {
    const targets = [];
    const targetSourceMap = {};
    widget.dragDrop.targets
        // need to strip tags in order to match database metric to target label
        .map(t => ({ ...t, label: striptags(t.label) }))
        .forEach(targ => {
            if (targ.reportDisabled) {
                return;
            }

            targetSourceMap[targ.label] = [];
            targets.push(targ);
        });

    const isOneDefinedTarget = targets.filter(t => t.id !== -1).length === 1;

    const data = metricsData[widget.assignmentId];
    const userInputReportHeaders = [];
    Object.values(widget.dragDrop.variableIdReportHeaderMapping).forEach(reportHeader => {
        if (reportHeader.includes('_duration') || reportHeader.includes('_incorrect')) {
            return;
        }

        // order so that user_input is always at the bottom
        if (reportHeader.includes('_user_text_')) {
            userInputReportHeaders.push(reportHeader);
            return;
        }

        const value = toDisplayText(data && data[reportHeader]);

        const sourceId = reportHeader.match(/[0-9]{1,}$/)[0];
        const source = widget.dragDrop.sources.find(s => Number(s.id) === Number(sourceId));

        if (value && source && Array.isArray(targetSourceMap[value])) {
            targetSourceMap[value].push(source.label);
        } else if (!value && source && Array.isArray(targetSourceMap.Unselected)) {
            targetSourceMap.Unselected.push(source.label);
        }
    });

    // now append the user_input variables to the bottom
    userInputReportHeaders.forEach(reportHeader => {
        const value = toDisplayText(data && data[reportHeader]);

        if (!value) {
            return;
        }

        // format for one target is `_user_text_<input_id>`
        // format for multiple targets is `_user_text_<target_id>_<input_id>`
        let match = isOneDefinedTarget
            ? reportHeader.match(/_user_text_[0-9]{1,}$/)
            : reportHeader.match(/_user_text_[0-9]{1,}_[0-9]{1,}$/);

        if (!Array.isArray(match)) {
            return;
        }

        let targetId;
        if (isOneDefinedTarget) {
            targetId = targets[0].id;
        } else {
            match = match[0].replace('_user_text_', '').split('_');
            targetId = match[0];
        }

        const target = targets.find(t => Number(t.id) === Number(targetId));
        if (target && targetSourceMap[target.label]) {
            targetSourceMap[target.label].push(value);
        }
    });

    return (
        <div className={style.dragDrop}>
            {widget?.questionText && <p className={style.question}>{widget.questionText}</p>}
            <div className={style.targets}>
                {targets.map(t => (
                    <div
                        className={`${style.target} ${targets.length > 1 ? style.multiple : ''}`}
                        style={{
                            flexBasis: `calc(${Math.floor(
                                100 / (targets.length <= 4 ? targets.length : targets.length / 2)
                            )}% - 16px)`,
                        }}
                        key={t.id}
                    >
                        <div className={style.label}>{t.reportLabel && <Html content={t.reportLabel} />}</div>
                        <ul>
                            {targetSourceMap[t.label].length === 0 ? (
                                <li
                                    className={`${style.answer} ${style.empty}`}
                                    style={{ backgroundColor: answerBg }}
                                />
                            ) : (
                                targetSourceMap[t.label].map((answer, i) => (
                                    <li className={style.answer} key={i} style={{ backgroundColor: answerBg }}>
                                        {striptags(toDisplayText(answer))}
                                    </li>
                                ))
                            )}
                        </ul>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DragDropRender;
